import { type Dispatch } from 'react'

import {
  type JobVariable,
  type JobVariableType,
  type JobVariableVisibility,
  type VariableScope
} from 'job-lib/types/Variables'

export enum Stages {
  MANAGE = 'MANAGE',
  CREATE = 'CREATE',
  DELETE = 'DELETE',
  EDIT = 'EDIT'
}

export enum ReducerActions {
  UPDATE_FIELD = 'UPDATE_FIELD',
  VALIDATE_FORM = 'VALIDATE_FORM',
  UPDATE_NAME = 'UPDATE_NAME',
  UPDATE_PROJECT_OVERRIDE = 'UPDATE_PROJECT_OVERRIDE',
  UPDATE_DEFAULT_VALUE = 'UPDATE_DEFAULT_VALUE',
  UPDATE_VARIABLE_TYPE = 'UPDATE_VARIABLE_TYPE'
}

export enum Fields {
  NAME = 'NAME',
  DESCRIPTION = 'DESCRIPTION',
  VISIBILITY = 'VISIBILITY',
  DEFAULT_VALUE = 'DEFAULT_VALUE',
  PROJECT_DEFAULT_OVERRIDES = 'PROJECT_DEFAULT_OVERRIDES'
}

export enum ErrorStatuses {
  'RESERVED_WORD' = 'RESERVED_WORD',
  'DUPLICATE' = 'DUPLICATE',
  'EMPTY' = 'EMPTY',
  'NO_ERROR' = 'NO_ERROR',
  'SELECT_OPTION' = 'SELECT_OPTION',
  'INCORRECT_NAME_FORMAT' = 'INCORRECT_NAME_FORMAT',
  'INCORRECT_NUMBER_FORMAT' = 'INCORRECT_NUMBER_FORMAT',
  'SINGLE_$' = 'SINGLE_S'
}
export interface SelectedJobVariable {
  type: VariableScope.JOB_VARIABLE
  name: string
}

export interface SelectedProjectVariable {
  type: VariableScope.PROJECT_VARIABLE
  name: string
  id: string
}

export type SelectedVariable = SelectedJobVariable | SelectedProjectVariable

export enum ProjectVariableType {
  NUMBER = 'NUMBER',
  TEXT = 'TEXT'
}

export enum ProjectVariableBehaviour {
  COPIED = 'COPIED',
  SHARED = 'SHARED'
}

type VariableType = JobVariableType | ProjectVariableType | null

export interface ManageVariableStageProps {
  onCancel: () => void
  setStage: Dispatch<Stages>
  setSelectedVariable?: Dispatch<SelectedVariable>
  setSelectedVariableScope?: Dispatch<VariableScope>
  selectedVariable?: SelectedVariable
  selectedVariableScope: VariableScope
  selectedVariableType?: VariableType
  setSelectedVariableType?: Dispatch<VariableType>
  onClose?: () => void
  isModalOpen?: boolean
  variableToEdit?: JobVariable | ProjectVariable
}

export interface FieldStatus<T> {
  value: T
  isValid: null | boolean
  error: string
}

export interface FieldState {
  [Fields.DESCRIPTION]: FieldStatus<string>
  [Fields.NAME]: FieldStatus<string>
  [Fields.DEFAULT_VALUE]: FieldStatus<string>
  [Fields.VISIBILITY]: FieldStatus<JobVariableVisibility | null>
  [Fields.PROJECT_DEFAULT_OVERRIDES]: FieldStatus<ProjectDefaultOverrides>
}
export interface FormState extends FieldState {
  isFormValid: boolean
}

export type ProjectDefaultOverrides = Record<
  ProjectVariableOverride['environmentId'],
  ProjectVariableOverride
>

export interface ProjectVariableOverride {
  value: string | number | null
  environmentId: string
  isValid?: boolean
  error?: string
}

export interface ProjectVariable {
  id: string
  name: string
  type: ProjectVariableType
  behaviour: ProjectVariableBehaviour
  description: string
  value: string | number | null
  overrides: ProjectVariableOverride[]
}
